<div class="not-found-wrapper">
  <div class="not-found-contents">
    <img loading="lazy" src="assets/403.png">
    <h4>Access denied</h4>
    <p class="lg">You don't have permission to access this page.</p>
    <button class="btn btn-primary mt-3" (click)="coreService.goHome()">Return Home</button>
  </div>
</div>